export default __webpack_public_path__ + "locales/pl/SMTPSettings.json?hash=7044b9a12692b848376be7290e2d9709";